import axiosInstance from './axios';

export interface Invoice {
    id: string;
    numero: string;
    cliente: string;
    nit: string;
    fechaEmision: string;
    fechaVencimiento: string;
    monto: number;
    tipo: 'MENSUALIDAD' | 'SERVICIO' | 'MULTA' | 'OTRO';
    concepto: string;
    metodoPago?: 'EFECTIVO' | 'TARJETA' | 'TRANSFERENCIA';
    status: 'PAGADA' | 'PENDIENTE' | 'VENCIDA' | 'ANULADA';
    clienteEmpresa?: {
        nombre: string;
        plan?: {
            nombre: string;
        }
    };
}

export interface CreateInvoiceData {
    clienteEmpresaId: string;
    monto: number;
    fechaVencimiento: string;
    tipo: 'MENSUALIDAD' | 'SERVICIO' | 'MULTA' | 'OTRO';
    concepto: string;
    status?: 'PAGADA' | 'PENDIENTE' | 'VENCIDA' | 'ANULADA';
}

export const getInvoices = async (): Promise<Invoice[]> => {
    const response = await axiosInstance.get<Invoice[]>('/invoices');
    return response.data;
};

export const createInvoice = async (data: CreateInvoiceData): Promise<Invoice> => {
    const response = await axiosInstance.post<Invoice>('/invoices', data);
    return response.data;
};

export const updateInvoiceStatus = async (id: string, status: string): Promise<Invoice> => {
    const response = await axiosInstance.patch<Invoice>(`/invoices/${id}/status`, { status });
    return response.data;
};

export const sendInvoiceReminder = async (id: string): Promise<void> => {
    await axiosInstance.post(`/invoices/${id}/remind`);
};
